import UAParser from 'ua-parser-js';

function printModusignRecruitment() {
  const parser = new UAParser();
  const userInfo = parser.getResult();

  const userBrowserName = userInfo.browser.name;

  if (userBrowserName === 'IE') {
    // eslint-disable-next-line no-console
    console.log(`
    ███╗   ███╗ ██████╗ ███████╗ ██╗   ██╗ ███████╗██╗ ███████╗███╗  ██╗
    ████╗ ████║██╔═══██╗██╔═══██╗██║   ██║██╔═════╝██║██╔═════╝████╗ ██║
    ██╔████╔██║██║   ██║██║   ██║██║   ██║╚██████╗ ██║██║ ████╗██║██╗██║
    ██║╚██╔╝██║██║   ██║██║   ██║██║   ██║ ╚════██╗██║██║ ╚═██║██║ ████║
    ██║ ╚═╝ ██║╚██████╔╝███████╔╝╚██████╔╝███████╔╝██║╚███████║██║  ███║
    ╚═╝     ╚═╝ ╚═════╝ ╚══════╝  ╚═════╝ ╚══════╝ ╚═╝ ╚══════╝╚═╝  ╚══╝
  
    모두싸인과 함께 성장할 인재를 찾습니다. : https://recruit.modusign.co.kr/
   `);
  } else {
    // eslint-disable-next-line no-console
    console.log(
      `%c
    ███╗   ███╗ ██████╗ ███████╗ ██╗   ██╗ ███████╗██╗ ███████╗███╗  ██╗
    ████╗ ████║██╔═══██╗██╔═══██╗██║   ██║██╔═════╝██║██╔═════╝████╗ ██║
    ██╔████╔██║██║   ██║██║   ██║██║   ██║╚██████╗ ██║██║ ████╗██║██╗██║
    ██║╚██╔╝██║██║   ██║██║   ██║██║   ██║ ╚════██╗██║██║ ╚═██║██║ ████║
    ██║ ╚═╝ ██║╚██████╔╝███████╔╝╚██████╔╝███████╔╝██║╚███████║██║  ███║
    ╚═╝     ╚═╝ ╚═════╝ ╚══════╝  ╚═════╝ ╚══════╝ ╚═╝ ╚══════╝╚═╝  ╚══╝
  
    모두싸인과 함께 성장할 인재를 찾습니다. : https://recruit.modusign.co.kr/
    `,
      'font-family:"courier new";color:#1976d2;font-size:12px;'
    );
  }
}

export default printModusignRecruitment;
